// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3ES7P","dragIcon":"Choice_dragIcon__1rPJz","left":"Choice_left__3Zay2","input":"Choice_input__30W1b"};